module.exports = __webpack_public_path__ + "img/taiping.60f88859.png";